/* SALWAR MAHAL compact product page helpers (styles live in sm-pdp-compact.css). */
(function () {
  if (!/\/products\//.test(location.pathname)) return;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function money(n) { return 'AED ' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); }
  function priceNow() {
    var p = q('.product__info-container .price');
    if (!p) return 0;
    var el = q(p.classList.contains('price--on-sale') ? '.price__sale .price-item--last' : '.price__regular .price-item--regular', p);
    return el ? parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0 : 0;
  }

  /* 1. Tabby: Tabby rebuilds its whole widget on every size change (blank, then a tall loading box,
        then its text), which looks like the page refreshing. So we show our own steady line,
        "[tabby] 4 interest-free payments of AED 47.50" (price / 4 = Tabby's no-fee plan), and keep
        Tabby's widget hidden underneath. Tapping our line opens Tabby's real info popup. */
  var TABBY_LOGO = "<svg class=\"sm-tabby__logo\" aria-hidden=\"true\" focusable=\"false\" viewBox=\"0 0 254 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#6CFF93\" d=\"M0 50c0-18.782 0-28.172 4.065-35.153a29.894 29.894 0 0 1 10.77-10.779C21.81 0 31.193 0 49.96 0h154.08c18.767 0 28.15 0 35.125 4.068a29.89 29.89 0 0 1 10.77 10.78C254 21.828 254 31.218 254 50s0 28.172-4.065 35.153a29.89 29.89 0 0 1-10.77 10.779C232.19 100 222.807 100 204.04 100H49.96c-18.767 0-28.15 0-35.125-4.068a29.894 29.894 0 0 1-10.77-10.78C0 78.172 0 68.782 0 50Z\" fill=\"#6CFF93\"></path><path fill=\"#000000\" d=\"M207.01 33.094v15.341c0 3.567 1.412 5.518 4.505 5.518 3.782 0 5.647-2.355 5.647-7.67v-13.19h13.111v25.705c0 14.13-9.108 21.851-21.044 21.851-8.301 0-12.923-2.488-15.868-5.303v-12.49c2.623 3.768 6.9 6.36 13.371 6.36 5.856 0 11.454-2.962 11.454-10.296v-1.346c-1.95 5.181-6.266 7.213-11.31 7.213-6.923 0-13.044-5.114-13.044-14.063v-17.63h13.178Zm-130.302-1.01c5.782 0 9.682 2.557 11.968 7.335v-6.325h13.178V72.12H88.676v-7.334c-2.219 5.316-6.186 8.344-11.968 8.344-8.472 0-14.522-7.604-14.523-21.532 0-12.583 6.051-19.515 14.523-19.515Zm43.098-8.411v15.746c2.286-4.777 6.185-7.335 11.967-7.335 8.472 0 14.59 6.931 14.59 19.515 0 13.928-6.118 21.532-14.59 21.532-5.782 0-9.749-3.028-11.967-8.344v7.334h-13.178V23.673h13.178Zm43.635 0v15.746c2.286-4.778 6.186-7.335 11.968-7.335 8.472 0 14.524 6.864 14.524 19.515-.001 13.996-6.052 21.532-14.524 21.532-5.782 0-9.749-3.028-11.968-8.344v7.334h-13.177V23.673h13.177Zm-118.864 0v9.42h13.63v9.69h-13.63v4.037h13.63v9.69h-13.63c.068 3.365 1.883 4.846 5.581 4.846 2.31 0 4.753-.67 8.049-2.208v11.036c-2.713 1.457-6.527 2.753-11.165 2.745-8.5-.015-15.643-4.404-15.643-15.544v-.874h-9.12l-.605-9.69h9.725v-4.038h-9.86l-.604-9.69h10.464v-9.42h13.178Zm37.645 18.303c-4.034 0-6.388 3.23-6.388 8.95 0 5.72 2.354 8.949 6.388 8.949 4.168 0 6.386-3.23 6.386-8.95 0-5.719-2.218-8.95-6.386-8.95Zm87.674 0c-4.101 0-6.455 3.096-6.455 8.95.001 5.854 2.354 8.949 6.455 8.949 4.034 0 6.387-3.23 6.387-8.95 0-5.719-2.353-8.95-6.387-8.95Zm-43.703 0c-4.101 0-6.387 3.297-6.387 8.95 0 5.248 2.286 8.276 6.387 8.276 4.101 0 6.387-2.96 6.387-8.276 0-5.854-2.285-8.95-6.387-8.95Z\" fill=\"#000\"></path></svg>";
  function tabbyLearnMore() {
    var host = q('#TabbyPromo [class*="containerPortal"]');
    var sr = host && host.shadowRoot;
    return sr && sr.querySelector('[data-test="widget-learn-more"]');
  }
  function styleTabby() {
    var tp = q('.product__info-container #TabbyPromo');
    if (!tp) return;
    var block = tp.closest('.shopify-app-block') || tp.parentElement;
    var price = priceNow();
    // wait until Tabby has shown itself once (it hides for prices it can't finance)
    if (!block.dataset.smTabbySeen) {
      if (!tabbyLearnMore()) return;
      block.dataset.smTabbySeen = '1';
    }
    var line = block.querySelector('.sm-tabby');
    if (!line) {
      line = document.createElement('button');
      line.type = 'button';
      line.className = 'sm-tabby';
      line.setAttribute('aria-label', 'Pay with tabby: see payment options');
      line.addEventListener('click', function () { var m = tabbyLearnMore(); if (m) m.click(); });
      block.insertBefore(line, tp);
      block.classList.add('sm-tabby-on');
    }
    var html = TABBY_LOGO + '<span>4 interest-free payments of <b>' + money(price / 4) + '</b></span>';
    if (price && line.dataset.price !== String(price)) { line.innerHTML = html; line.dataset.price = String(price); }
    line.hidden = !price;
  }

  /* 2. Delivery: "Order within 15h 43m to get it by Tomorrow, 21 Oct" (mirrors the theme's own
        countdown, which keeps running hidden underneath). */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function shortDate(t) {
    var m = t.match(/([A-Za-z]{3})[a-z]*,?\s*(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (!m) return t.trim();
    var d = new Date(+m[4], +m[3] - 1, +m[2]);
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var diff = Math.round((d - today) / 864e5);
    var label = parseInt(m[2], 10) + ' ' + MONTHS[+m[3] - 1];
    if (diff === 0) return 'Today, ' + label;
    if (diff === 1) return 'Tomorrow, ' + label;
    return m[1] + ' ' + label;
  }
  // "Fri 23 Oct", "Mon 26 Oct" -> "Fri 23 – Mon 26 Oct" when both fall in the same month
  function dateRange(a, b) {
    var x = shortDate(a), y = shortDate(b);
    var mx = x.match(/(.*\d)\s([A-Z][a-z]{2})$/), my = y.match(/\s([A-Z][a-z]{2})$/);
    if (mx && my && mx[2] === my[1] && !/^(Today|Tomorrow)/.test(x)) return mx[1] + ' – ' + y;
    return x + ' – ' + y;
  }
  function shortTime(t) {
    return t.replace(/(\d+)\s*hours?/i, '$1h').replace(/(\d+)\s*minutes?/i, '$1m').replace(/\s+/g, ' ').trim();
  }
  var VAN_UAE = '<svg class="sm-eta-van" style="display:block;flex-shrink:0;width:2.7rem;height:1.6rem" viewBox="0 0 34 20" width="27" height="16" role="img" aria-label="UAE delivery"><rect x="1" y="2" width="20" height="4.2" fill="#00732f"/><rect x="1" y="6.2" width="20" height="4.2" fill="#fff"/><rect x="1" y="10.4" width="20" height="4.1" fill="#000"/><rect x="1" y="2" width="5" height="12.5" fill="#e8112d"/><rect x="1" y="2" width="20" height="12.5" rx="1.4" fill="none" stroke="#2b2b2b" stroke-width="1"/><path d="M22.2 5.5h6l4.3 5.2v3.8H22.2z" fill="#701d1c"/><path d="M23.7 7h4l2.6 3.3h-6.6z" fill="#fff" opacity=".9"/><rect x="1" y="14.2" width="31.5" height="1.3" rx=".6" fill="#2b2b2b"/><circle cx="7" cy="16.3" r="2.7" fill="#2b2b2b"/><circle cx="7" cy="16.3" r="1" fill="#fff"/><circle cx="27" cy="16.3" r="2.7" fill="#2b2b2b"/><circle cx="27" cy="16.3" r="1" fill="#fff"/></svg>';
  function compactEta() {
    var cd = document.getElementById('countdown');
    if (!cd || !cd.parentElement || !cd.textContent.trim()) return;
    var src = cd.parentElement;
    var by = document.getElementById('deliveryDate');
    var a = document.getElementById('deliveryDateStart');
    var b = document.getElementById('deliveryDateEnd');
    var when = by ? shortDate(by.textContent) : (a && b ? dateRange(a.textContent, b.textContent) : null);
    if (!when) return;
    var out = src.parentElement.querySelector('.sm-eta');
    if (!out) {
      out = document.createElement('span');
      out.className = 'sm-eta';
      src.after(out);
      src.classList.add('sm-eta-src');
      // the truck picture becomes a van with the UAE flag on it (28 Oct 2026)
      var pic = src.parentElement.querySelector(':scope > img');
      if (pic) { var van = document.createElement('span'); van.style.cssText = 'display:inline-flex;flex-shrink:0'; van.innerHTML = VAN_UAE; pic.replaceWith(van); }
      new MutationObserver(compactEta).observe(src, { subtree: true, characterData: true, childList: true });
    }
    var time = shortTime(cd.textContent);
    // longest first; use the first that fits on one line
    var options = [
      'Get it <span class="sm-eta-date">' + when + '</span> · order within <span class="sm-eta-time">' + time + '</span>',
      'Get it <span class="sm-eta-date">' + when + '</span> · order in <span class="sm-eta-time">' + time + '</span>',
      'Get it <span class="sm-eta-date">' + when.replace(/^(Today|Tomorrow), /, '$1 ') + '</span> · <span class="sm-eta-time">' + time + '</span> left'
    ];
    for (var i = 0; i < options.length; i++) {
      if (out.innerHTML !== options[i]) out.innerHTML = options[i];
      if (out.scrollWidth <= out.clientWidth + 1) break;
    }
  }

  /* 4. Sale: the theme's "Sale" badge becomes "13% off" next to the crossed-out price. */
  function saleBadge() {
    var p = q('.product__info-container .price');
    if (!p) return;
    var badge = q('.price__badge-sale', p);
    if (!badge) return;
    var was = q('.price__sale s.price-item--regular', p);
    var now = q('.price__sale .price-item--last', p);
    var w = was && parseFloat(was.textContent.replace(/[^0-9.]/g, ''));
    var n = now && parseFloat(now.textContent.replace(/[^0-9.]/g, ''));
    var text = w && n && w > n ? Math.round((1 - n / w) * 100) + '% off' : 'Sale';
    if (badge.textContent.trim() !== text) badge.textContent = text;
  }

  /* 5. Description: a line that is only a bold heading ("Additional Description:") is not a spec row */
  function markDescHeads() {
    document.querySelectorAll('.product__description p:not(.sm-desc-checked)').forEach(function (p) {
      p.classList.add('sm-desc-checked');
      var s = p.querySelector(':scope > strong:first-child');
      if (s && p.textContent.trim() === s.textContent.trim()) p.classList.add('sm-desc-head');
    });
  }

  /* 6. Faster size switching. Every size tap makes the theme ask Shopify for the updated product
        section (~26 KB). We ask for each size's version once the page is idle, keep it for 2 minutes,
        and hand it straight back when the theme asks, so the switch is instant. */
  var cache = {};
  var TTL = 120000;
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var hit = url && cache[url];
    if (hit && Date.now() - hit.at < TTL && hit.text) {
      delete cache[url];
      setTimeout(prefetchSizes, 400);
      return Promise.resolve(new Response(hit.text, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } }));
    }
    return nativeFetch.apply(this, arguments);
  };
  function prefetchSizes() {
    var info = q('product-info[data-section]');
    if (!info || !info.dataset.url) return;
    var sets = info.querySelectorAll('variant-selects fieldset');
    var current = [], sizeIdx = -1;
    sets.forEach(function (f, i) {
      var c = f.querySelector('input:checked');
      current.push(c ? c.dataset.optionValueId : null);
      var lg = q('legend', f);
      if (lg && /size/i.test(lg.textContent)) sizeIdx = i;
    });
    if (sizeIdx < 0 || current.indexOf(null) !== -1) return;
    sets[sizeIdx].querySelectorAll('input[type="radio"]').forEach(function (inp) {
      if (inp.checked || inp.dataset.productUrl) return;
      var ids = current.slice();
      ids[sizeIdx] = inp.dataset.optionValueId;
      // must match product-info.js buildRequestUrlWithParams() exactly
      var url = info.dataset.url + '?section_id=' + (info.dataset.originalSection || info.dataset.section) + '&option_values=' + ids.join(',');
      if (cache[url] && Date.now() - cache[url].at < TTL) return;
      cache[url] = { at: Date.now() };
      nativeFetch(url).then(function (r) { return r.ok ? r.text() : null; }).then(function (t) {
        if (t) cache[url].text = t; else delete cache[url];
      }).catch(function () { delete cache[url]; });
    });
  }

  /* 7. Desktop: the photo column stays put while the details scroll (Noon style). If the photos are
        taller than the screen, let them scroll until their bottom shows, then hold. */
  function pinGallery() {
    var g = q('.product > .product__media-wrapper');
    if (!g || !window.matchMedia('(min-width: 990px)').matches) return;
    var header = q('sticky-header, .section-header');
    var banner = q('#smartAppBanner.show');
    var hb = Math.max(0, header ? header.getBoundingClientRect().bottom : 0,
      banner && getComputedStyle(banner).position === 'fixed' ? banner.getBoundingClientRect().bottom : 0);
    // keep the top of the photo (faces) in view; a tall photo loses a little at the bottom instead
    var top = hb + 16;
    document.documentElement.style.setProperty('--sm-gallery-top', Math.round(top) + 'px');
  }

  /* 8. Mobile: the back button lives on the photo itself (top-left, Noon style), so it travels with
        the photo instead of chasing the header. Desktop and other pages keep it in the corner. */
  function placeBack() {
    var b = document.getElementById('pwaBackButton');
    var photo = q('.product > .product__media-wrapper');
    if (!b || !photo) return;
    // the photo column sticks below the "Download app" banner while that banner is open
    var banner = q('#smartAppBanner.show');
    var bh = banner && getComputedStyle(banner).position === 'fixed' ? Math.max(0, banner.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--sm-banner-h', Math.round(bh) + 'px');
    // when the header slides back in (scrolling up), the photo column (stories + photos) slides down
    // with it so the stories row isn't hidden behind the header
    var head = q('.section-header');
    var headBottom = 0;
    if (head && head.classList.contains('shopify-section-header-sticky') && !head.classList.contains('shopify-section-header-hidden')) {
      var shift = new DOMMatrix(getComputedStyle(head).transform).m42 || 0; // ignore the slide-in animation
      headBottom = Math.max(0, head.getBoundingClientRect().bottom - shift);
    }
    document.documentElement.style.setProperty('--sm-photo-top', Math.round(Math.max(bh, headBottom)) + 'px');
    var mobile = !window.matchMedia('(min-width: 750px)').matches;
    if (mobile && b.parentNode !== photo) { photo.appendChild(b); b.classList.add('sm-back-top'); }
    if (!mobile && b.parentNode === photo) { document.body.appendChild(b); b.classList.remove('sm-back-top'); }
  }

  /* 10. Stories row moves into the photo column, above the photos, so it stays pinned with them
         (a quick scroller can't miss it). Its height feeds the back button's position. */
  function placeStories() {
    var st = q('.product-video-stories');
    var photo = q('.product > .product__media-wrapper');
    if (!st || !photo) return;
    if (st.parentNode !== photo) { photo.insertBefore(st, photo.firstChild); st.classList.add('sm-stories'); }
    document.documentElement.style.setProperty('--sm-stories-h', st.offsetHeight + 'px');
  }

  /* 9. Info dropdowns (FREE Shipping, Easy Returns, Disclaimer) become a row of icon tiles (Noon style).
        Tapping a tile opens its text in a small panel. The original dropdowns stay in the page, hidden,
        so the wording still comes from the theme editor and Google still reads it. */
  var perkSheet;
  function openPerk(title, html) {
    if (!perkSheet) {
      perkSheet = document.createElement('div');
      perkSheet.className = 'sm-perk-sheet';
      perkSheet.innerHTML = '<div class="sm-perk-sheet__backdrop"></div><div class="sm-perk-sheet__card" role="dialog" aria-modal="true" aria-labelledby="SmPerkTitle"><div class="sm-perk-sheet__head"><div class="sm-perk-sheet__title" id="SmPerkTitle"></div><button type="button" class="sm-perk-sheet__close" aria-label="Close">&times;</button></div><div class="sm-perk-sheet__body rte"></div></div>';
      document.body.appendChild(perkSheet);
      perkSheet.addEventListener('click', function (e) { if (e.target.closest('.sm-perk-sheet__close, .sm-perk-sheet__backdrop')) closePerk(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePerk(); });
    }
    q('.sm-perk-sheet__title', perkSheet).textContent = title;
    var body = q('.sm-perk-sheet__body', perkSheet);
    body.innerHTML = html;
    // a line break typed mid-sentence inside a bullet reads oddly in the small panel: make it a space
    body.querySelectorAll('li br').forEach(function (br) { br.replaceWith(' '); });
    perkSheet.classList.add('is-open');
    document.documentElement.classList.add('sm-perk-open');
    q('.sm-perk-sheet__close', perkSheet).focus({ preventScroll: true });
  }
  function closePerk() {
    if (!perkSheet || !perkSheet.classList.contains('is-open')) return;
    perkSheet.classList.remove('is-open');
    document.documentElement.classList.remove('sm-perk-open');
  }
  function perkTiles() {
    var accs = [].slice.call(document.querySelectorAll('.product__info-container .product__accordion:not(.sm-perk-src)'));
    if (!accs.length) return;
    var row = document.createElement('div');
    row.className = 'sm-perks';
    accs.forEach(function (acc) {
      var title = q('.accordion__title', acc), body = q('.accordion__content', acc);
      if (!title || !body) return;
      var icon = q('.summary__title svg', acc);
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'sm-perk';
      tile.innerHTML = (icon ? icon.outerHTML : '') + '<span class="sm-perk__title"></span><span class="sm-perk__more">Details</span>';
      q('.sm-perk__title', tile).textContent = title.textContent.trim();
      tile.addEventListener('click', function () { openPerk(title.textContent.trim(), body.innerHTML); });
      row.appendChild(tile);
      acc.classList.add('sm-perk-src');
    });
    if (row.children.length) accs[0].parentNode.insertBefore(row, accs[0]);
    row.classList.add('sm-perks--' + row.children.length);
  }

  var pinQueued = false;
  function queuePin() { if (!pinQueued) { pinQueued = true; requestAnimationFrame(function () { pinQueued = false; pinGallery(); placeBack(); }); } }

  function run() { styleTabby(); compactEta(); saleBadge(); markDescHeads(); perkTiles(); }
  function init() {
    run();
    var root = document.querySelector('.product__info-container') || document.body;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
    root.addEventListener('change', function () { setTimeout(run, 30); });
    placeStories();
    pinGallery();
    placeBack();
    var headEl = q('.section-header');
    if (headEl) new MutationObserver(placeBack).observe(headEl, { attributes: true, attributeFilter: ['class'] });
    // Tabby draws itself inside its own hidden box, which page watchers can't see, so when it loads
    // late keep checking (every half second, up to 20s) until our one-line version is in place
    var tabbyTries = 0, tabbyTimer = setInterval(function () {
      styleTabby();
      if (q('.sm-tabby') || ++tabbyTries > 40) clearInterval(tabbyTimer);
    }, 500);
    window.addEventListener('scroll', queuePin, { passive: true });
    window.addEventListener('resize', function () { placeStories(); queuePin(); });
    document.addEventListener('click', function () { setTimeout(placeBack, 400); }, true); // banner closed
    window.addEventListener('load', queuePin);
    window.addEventListener('sm:sticky', function () { setTimeout(pinGallery, 0); setTimeout(pinGallery, 260); });
    var idle = window.requestIdleCallback || function (f) { setTimeout(f, 1500); };
    setTimeout(function () { idle(prefetchSizes); }, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
